import { render, staticRenderFns } from "./VehicleHistory.vue?vue&type=template&id=6f479239&"
import script from "./VehicleHistory.vue?vue&type=script&lang=js&"
export * from "./VehicleHistory.vue?vue&type=script&lang=js&"
import style0 from "./VehicleHistory.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports